import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, REGIONS, SHAPES } from '../gameData';

export default class BlueBuildingArea extends RegionArea
{
    /**
     * Create the blue building area.
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[REGIONS.DOWNTOWN].BLUE_BUILDING);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.hexagon.setAlpha(0);
        this.square0.setAlpha(0);
        this.square1.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.hexagon.disableInteractive();
        this.square0.disableInteractive();
        this.square1.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.hexagon.setAlpha(0.000001);
        this.square0.setAlpha(0.000001);
        this.square1.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let hexagonHitArea = new Phaser.Geom.Polygon(
            [
                { x: 54, y: 84 },
                { x: 18, y: 63 },
                { x: 20, y: 0 },
                { x: 55, y: 20 },
                { x: 73, y: 62 },
            ]);
        this.hexagon = ABCya.Images.addImage(537, 324, UIAssetKeys._08_Downtown_Zoom_In_Blue_Building_BluBldg_Slct_Hex, this.parentRegion).setInteractive(hexagonHitArea, Phaser.Geom.Polygon.Contains);
        this.hexagon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.hexagon, SHAPES.HEXAGON);
        });

        let square0HitArea = new Phaser.Geom.Polygon(
            [
                { x: 101, y: 172 },
                { x: 2, y: 115 },
                { x: 2, y: 2 },
                { x: 101, y: 58 },
            ]);
        this.square0 = ABCya.Images.addImage(576, 537, UIAssetKeys._08_Downtown_Zoom_In_Blue_Building_BluBldg_Slct_Sqr1, this.parentRegion).setInteractive(square0HitArea, Phaser.Geom.Polygon.Contains);
        this.square0.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.square0, SHAPES.SQUARE);
        });

        let square1HitArea = new Phaser.Geom.Polygon(
            [
                { x: 2, y: 99 },
                { x: 2, y: 31 },
                { x: 56, y: 2 },
                { x: 56, y: 69 },
            ]);
        this.square1 = ABCya.Images.addImage(777, 538, UIAssetKeys._08_Downtown_Zoom_In_Blue_Building_BluBldg_Slct_Sqr2, this.parentRegion).setInteractive(square1HitArea, Phaser.Geom.Polygon.Contains);
        this.square1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.square1, SHAPES.SQUARE);
        });

        this.shapeOverlays[SHAPES.HEXAGON] = [this.hexagon];
        this.shapeOverlays[SHAPES.SQUARE] = [this.square0, this.square1];

        this._createAreaInformation(0x5f5fd6, 0x2b4270);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.greenBuilding, this.parentRegion.treeAndBenchContainer, this.parentRegion.peachBuilding
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.blueBuilding, duration: 1000, props: { scale: 1, x: 728, y: 393 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.hexagon.disableInteractive();
        this.square0.disableInteractive();
        this.square1.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.blueBuilding, duration: 1000, props: { scale: .5714, x: this.parentRegion.blueBuilding.onScreenPosition.x, y: this.parentRegion.blueBuilding.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.greenBuilding, this.parentRegion.treeAndBenchContainer, this.parentRegion.peachBuilding], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}